import { useSelector } from 'react-redux';
import { FiFrown, FiSmile } from 'react-icons/fi';
import numeral from 'numeral';
import _ from 'lodash';

const WidgetLotteryResult = () => {
  const lottoResult = useSelector(state => state?.navData?.result);
  // console.log('lottoResult', lottoResult);
  if (_.isEmpty(lottoResult?.results)) return null;
  return (
    <div className='lottery-result-box'>
      <h3>ผลสลากกินแบ่งรัฐบาล</h3>
      <p>{lottoResult.date}</p>
      {lottoResult.results.map((item, i) => (
        <div className='lottery-result-list' key={i}>
          <h4 className='lottery-result-item'>{item.lottoNo}</h4>
          {item.award.length === 0 ? (
            <h5 className='lottery-result-item'>
              คุณไม่ถูกรางวัล
              <FiFrown color={'red'} />
            </h5>
          ) : (
            item.award.map((data, i) => (
              <h5 key={i} className={`lottery-result-item ${i + 1 > 1 ? '--full' : ''}`}>
                ยินดีด้วย คุณถูก{data.award} <span>{numeral(data.price).format('0,0')} บาท</span>
                <FiSmile color={'green'} />
              </h5>
            ))
          )}
        </div>
      ))}
    </div>
  );
};

export default WidgetLotteryResult;
